import { ThemeBtn } from './styles';
import { useThemeContext } from '../../context/theme';
import { RiSunFill, RiMoonClearFill } from 'react-icons/ri';

const ThemeButton = () => {
  const { darkMode, toggleDarkMode } = useThemeContext();

  const handleToggleTheme = () => {
    toggleDarkMode();
  };

  return (
    <ThemeBtn onClick={handleToggleTheme} isDarkMode={darkMode}>
      {darkMode ? <RiMoonClearFill /> : <RiSunFill />}
    </ThemeBtn>
  );
};

export default ThemeButton;
